import type { SectionInsightsDto } from './reportEnums.constants';

/** Studio copy for VBP Engagement clinical and financial insight cards. */
export const VBP_ENGAGEMENT_INSIGHTS: SectionInsightsDto = {
  clinical: {
    heading: 'Engagement is the precondition for every clinical outcome.',
    body: "Members who don't engage with care see no measurable improvement in chronic disease control, behavioral health symptoms, or preventive care completion. Reema's engagement rate with VBP-eligible members exceeds the 5 to 15% rate typical of outreach to Medicaid populations.",
    citationLabel: 'Citation',
    citationUrl: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4651160/',
  },
  financial: {
    heading: 'Reaching the unreachable is where the savings live.',
    body: "The top 5% of Medicaid patients account for nearly 50% of program spending, and they are disproportionately the same members who don't respond to standard outreach. Engaging this population is the only path to bending their cost curve.",
    citationLabel: 'Citation',
    citationUrl: 'https://www.ncbi.nlm.nih.gov/books/NBK613741/',
  },
};
